import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { withSession } from '../../../i18n/containers/AppInit.js';

import {
  Button,
  Popover,
  Radio,
  RadioButtonGroup
} from '@salesforce/design-system-react';

import './ProfileStatus.scss';

class ProfileStatus extends Component {
  constructor(props) {
    super(props);
    this.state = {
      statusPopupIsOpen: false,
      forgetPopupIsOpen: false,
      unForgetPopupIsOpen: false,
      statusChanged: false,
      tempStatus: this.props.profile?.processingStatus || 'STANDARD'
    };
  }

  renderProfileStatusOption(session) {
    const { formatMessage } = this.props.intl;
    return (
      <div>
        <div className="profile-status-options">
          <RadioButtonGroup
            className="inline"
            onChange={event =>
              this.statusHandler(
                event.target.value !== this.props.profile.processingStatus,
                event.target.value
              )
            }
          >
            <Radio
              key="standard"
              id="standard"
              labels={{
                label: formatMessage({
                  id: 'components.ecs.selectionBrowser.profile.standard'
                })
              }}
              value="STANDARD"
              variant="base"
              checked={this.state.tempStatus === 'STANDARD'}
            />
            <Radio
              key="restricted"
              id="restricted"
              labels={{
                label: formatMessage({
                  id: 'components.ecs.selectionBrowser.profile.restricted'
                })
              }}
              value="RESTRICTED"
              variant="base"
              checked={this.state.tempStatus === 'RESTRICTED'}
            />
          </RadioButtonGroup>
        </div>

        <div className="profile-buttons">
          <Popover
            className="slds-text-align_left"
            align="right"
            position="overflowBoundaryElement"
            isOpen={this.state.statusPopupIsOpen}
            body={formatMessage({
              id:
                'components.ecs.selectionBrowser.profile.confirmation.description'
            })}
            footer={
              <div className="slds-text-align_right">
                <Button
                  label="Cancel"
                  onClick={() => this.handlePopupCancel('statusPopupIsOpen')}
                />
                <Button
                  variant={this.popOverColor(this.props.profiles)}
                  label={formatMessage({
                    id: `components.ecs.selectionBrowser.profile.confirmation.confirm`
                  })}
                  onClick={this.handleStatusChange(session)}
                />
              </div>
            }
            heading={formatMessage({
              id: `components.ecs.selectionBrowser.profile.confirmation.header`
            })}
            id="popover-controlled-with-footer"
            onClose={this.handleClose}
            onRequestClose={() => this.handleRequestClose('statusPopupIsOpen')}
          >
            <Button
              className="status-button"
              id="status"
              key="status"
              disabled={!this.state.statusChanged}
              variant={this.buttonColor(this.props.profile)}
              onClick={() => this.handlePopupOpen('statusPopupIsOpen')}
              label={formatMessage({
                id: `components.ecs.selectionBrowser.profile.update`
              })}
            />
          </Popover>
          <Popover
            className="slds-text-align_left"
            align="right"
            position="overflowBoundaryElement"
            isOpen={this.state.forgetPopupIsOpen}
            body={formatMessage({
              id: 'components.ecs.selectionBrowser.profile.forget.description'
            })}
            footer={
              <div className="slds-text-align_right">
                <Button
                  label="Cancel"
                  onClick={() => this.handlePopupCancel('forgetPopupIsOpen')}
                />
                <Button
                  variant={this.popOverColor(this.props.profiles)}
                  label={formatMessage({
                    id: `components.ecs.selectionBrowser.profile.forget.confirm`
                  })}
                  onClick={this.handleForgetChange(session)}
                />
              </div>
            }
            heading={formatMessage({
              id: `components.ecs.selectionBrowser.profile.forget.header`
            })}
            id="popover-controlled-with-footer"
            onClose={this.handleClose}
            onRequestClose={() => this.handleRequestClose('forgetPopupIsOpen')}
          >
            <Button
              className="forget-button"
              id="forget"
              key="forget"
              variant={this.buttonColor(this.props.profile)}
              onClick={() => this.handlePopupOpen('forgetPopupIsOpen')}
              label={formatMessage({
                id: `components.ecs.selectionBrowser.profile.forget.button`
              })}
            />
          </Popover>
        </div>
      </div>
    );
  }

  renderUnForgetOption(session) {
    const { formatMessage } = this.props.intl;
    return (
      <div>
        <div className="right-nav">
          <Popover
            className="slds-text-align_left"
            align="right"
            position="overflowBoundaryElement"
            isOpen={this.state.unForgetPopupIsOpen}
            body={formatMessage({
              id: 'components.ecs.selectionBrowser.profile.unforget.description'
            })}
            footer={
              <div className="slds-text-align_right">
                <Button
                  label="Cancel"
                  onClick={() => this.handlePopupCancel('unForgetPopupIsOpen')}
                />
                <Button
                  variant={this.popOverColor(this.props.profiles)}
                  label={formatMessage({
                    id: `components.ecs.selectionBrowser.profile.unforget.confirm`
                  })}
                  onClick={this.handleUnForgetChange(session)}
                />
              </div>
            }
            heading={formatMessage({
              id: `components.ecs.selectionBrowser.profile.unforget.header`
            })}
            id="popover-controlled-with-footer"
            onClose={this.handleClose}
            onRequestClose={() =>
              this.handleRequestClose('unForgetPopupIsOpen')
            }
          >
            <Button
              className="unforget-button"
              id="unforget"
              key="unforget"
              variant={this.buttonColor(this.props.profile)}
              onClick={() => this.handlePopupOpen('unForgetPopupIsOpen')}
              label={formatMessage({
                id: `components.ecs.selectionBrowser.profile.unforget.button`
              })}
            />
          </Popover>
        </div>
      </div>
    );
  }

  popOverColor(field) {
    if (field) {
      return 'destructive';
    } else {
      return 'brand';
    }
  }

  buttonColor(field) {
    if (field) {
      return 'brand';
    } else {
      return 'neutral';
    }
  }

  handleRequestClose(fieldState) {
    if (this.props.log) {
      this.props.log('onRequestClose');
    }
    this.setState({ [fieldState]: false });
  }

  handleClose = (event, data) => {
    if (this.props.log) {
      this.props.log('onClose')(event, data);
    }
  };

  handlePopupOpen(fieldState) {
    this.setState({ [fieldState]: true });
  }

  handlePopupCancel(fieldState) {
    this.setState({
      [fieldState]: false,
      statusChanged: false,
      tempStatus: this.props.profile.processingStatus
    });
  }

  handleStatusChange(session) {
    return () => {
      this.props.actions.editProfileStatus(
        this.props.profile.addresses[0].address,
        {
          processingStatus: this.state.tempStatus,
          callback: () => {
            this.setState({
              statusPopupIsOpen: false,
              statusChanged: false
            });
          },
          cToken: session.cToken
        }
      );
    };
  }

  handleForgetChange(session) {
    return () => {
      this.props.actions.editProfileStatus(
        this.props.profile.addresses[0].address,
        {
          processingStatus: 'PENDING',
          callback: () => {
            this.setState({
              forgetPopupIsOpen: false,
              statusChanged: false
            });
          },
          cToken: session.cToken
        }
      );
    };
  }

  handleUnForgetChange(session) {
    return () => {
      this.props.actions.editProfileStatus(
        this.props.profile.addresses[0].address,
        {
          processingStatus: 'RESTRICTED',
          callback: () => {
            this.setState({
              unForgetPopupIsOpen: false,
              statusChanged: false
            });
          },
          cToken: session.cToken
        }
      );
    };
  }

  statusHandler(hasChanged, status) {
    if (hasChanged) {
      this.setState({
        statusChanged: true,
        tempStatus: status
      });
    } else {
      this.setState({
        statusChanged: false,
        tempStatus: status
      });
    }
  }

  render() {
    return withSession(session => {
      return (
        <div className="profile-status">
          {this.props.profile.processingStatus === 'PENDING'
            ? this.renderUnForgetOption(session)
            : this.renderProfileStatusOption(session)}
        </div>
      );
    });
  }
}

ProfileStatus.contextTypes = {
  router: PropTypes.object
};

ProfileStatus.propTypes = {
  actions: PropTypes.object,
  profile: PropTypes.object,
  isLoading: PropTypes.bool,
  location: PropTypes.object
};

export default injectIntl(ProfileStatus);
